// ---------------------------------------------------------------------------
// Contact Lead — "Not getting confirmed tickets?" A/B test config
// ---------------------------------------------------------------------------

// Same orchestrator Lambda as flight / bus / hotel flows (intent = "contact_lead")
export const CONTACT_LEAD_API =
    'https://s4nvnzwoc8.execute-api.ap-south-1.amazonaws.com/default/tbo_api_orchesterator';

// Number dialled by the "Call Us" button.
// TODO: replace with the RouteChef support line before launch.
export const SUPPORT_PHONE = '+918655234915';

// Pretty version shown in the UI
export const SUPPORT_PHONE_DISPLAY = '+91 86552 34915';

// A/B arms. Bump the storage key version to re-randomise every user.
export const AB_VARIANTS = {
    BANNER: 'banner',
    CARD_BUTTON: 'card_button',
};
export const AB_STORAGE_KEY = 'rc_contact_ab_v1';

// QA override: add ?contact_ab=banner or ?contact_ab=card_button to the URL
export const AB_URL_OVERRIDE_PARAM = 'contact_ab';

// Banner copy (only used in the banner arm). One is picked per user and kept stable.
// `id` is sent to the backend as banner_text_id so copy performance can be compared too.
export const BANNER_TEXTS = [
    { id: 't1', headline: 'Not getting your preferred ticket?', cta: 'Give us a call' },
    { id: 't2', headline: 'Not getting your preferred ticket?', cta: 'Call us' },
    { id: 't3', headline: 'Confused about your travel?',        cta: 'Give us a call' },
    { id: 't4', headline: 'Not getting confirmed tickets?',     cta: 'Give us a call' },
    { id: 't5', headline: 'Not getting confirmed tickets?',     cta: 'Contact us' },
];

export const TRAIN_CLASS_OPTIONS = [
    { value: 'SL', label: 'Sleeper (SL)' },
    { value: '3A', label: '3rd AC (3A)' },
    { value: '2A', label: '2nd AC (2A)' },
    { value: '1A', label: '1st AC (1A)' },
];

export const FLIGHT_CLASS_OPTIONS = [
    { value: 'Economy',  label: 'Economy' },
    { value: 'Premium',  label: 'Premium Economy' },
    { value: 'Business', label: 'Business' },
    { value: 'First',    label: 'First' },
];

export const TRAIN_CLASS_VALUES  = TRAIN_CLASS_OPTIONS.map(o => o.value);
export const FLIGHT_CLASS_VALUES = FLIGHT_CLASS_OPTIONS.map(o => o.value);

export const MODE_OPTIONS = ['Train', 'Flight', 'Bus'];

export const COUNTRY_CODES = [
    { code: '+91',  iso: 'IN', name: 'India',        flag: '🇮🇳', minLen: 10, maxLen: 10 },
    { code: '+971', iso: 'AE', name: 'UAE',          flag: '🇦🇪', minLen: 8,  maxLen: 9  },
    { code: '+1',   iso: 'US', name: 'USA / Canada', flag: '🇺🇸', minLen: 10, maxLen: 10 },
    { code: '+44',  iso: 'GB', name: 'UK',           flag: '🇬🇧', minLen: 10, maxLen: 10 },
    { code: '+65',  iso: 'SG', name: 'Singapore',    flag: '🇸🇬', minLen: 8,  maxLen: 8  },
    { code: '+61',  iso: 'AU', name: 'Australia',    flag: '🇦🇺', minLen: 9,  maxLen: 9  },
    { code: '+966', iso: 'SA', name: 'Saudi Arabia', flag: '🇸🇦', minLen: 9,  maxLen: 9  },
    { code: '+974', iso: 'QA', name: 'Qatar',        flag: '🇶🇦', minLen: 8,  maxLen: 8  },
    { code: '+965', iso: 'KW', name: 'Kuwait',       flag: '🇰🇼', minLen: 8,  maxLen: 8  },
    { code: '+968', iso: 'OM', name: 'Oman',         flag: '🇴🇲', minLen: 8,  maxLen: 8  },
    { code: '+973', iso: 'BH', name: 'Bahrain',      flag: '🇧🇭', minLen: 8,  maxLen: 8  },
    { code: '+49',  iso: 'DE', name: 'Germany',      flag: '🇩🇪', minLen: 10, maxLen: 11 },
    { code: '+977', iso: 'NP', name: 'Nepal',        flag: '🇳🇵', minLen: 10, maxLen: 10 },
];
export const DEFAULT_COUNTRY_CODE = '+91';
